<template>
  <v-footer color="deep-purple lighten-1" padless>
    <v-row justify="center" no-gutters>
      <v-btn
        v-for="link in links"
        :key="link.name"
        :to=" link.routeName "
        color="white"
        text
        rounded
        class="my-2"
      >
        {{ link.name }}
      </v-btn>
      <v-col class="deep-purple lighten-2 py-4 text-center white--text" cols="12">
        <div class="social-links">
          <v-btn icon :href="'https://wa.me/255689118095' + whatsapp">
            <v-icon>mdi-whatsapp</v-icon>
          </v-btn>
          <v-btn icon :href="'tel:' + phone">
            <v-icon>mdi-phone</v-icon>
          </v-btn>
          <v-btn icon :href="'https://www.facebook.com/share/YiW1mhjWb84LWc1d/?mibextid=qi2Omg' + facebook">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon :href="'https://www.instagram.com/hassanayn_kashmal?igsh=bDJ0emc1bXB2MmU0' + instagram">
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
          <v-btn icon :href="'https://x.com/hassankashmal?t=QzDECh-Hv1emIwT8iEyvBQ&s=01' + tweeter">
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
        </div>
        <div>{{ new Date().getFullYear() }}&copy; Garage. All rights reserved.Developed By Kashmal</div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', routeName: '/' },
      { name: 'Service', routeName: '/services' },
      { name: 'Vehicle List', routeName: '/vehicle-list' },
      { name: 'Customers', routeName: '/customers' },
      { name: 'About Us', routeName: '/about' },
      { name: 'Register', routeName: '/register' }
    ],
    whatsapp: '',
    phone: '0689118095',
    facebook: 'kasanaautogarage',
    instagram: 'kasana_autogarage',
    location: 'Kinondoni Kasana',
  }),
}
</script>


